/** Highlight a task assigned to the signed-in assistant, regardless of owner. */
export function isAssignedToAssistant(
  task: { userId: string; assignedToUserId?: string | null },
  viewerId: string | undefined,
  isAssistantViewer: boolean,
): boolean {
  return !!isAssistantViewer && !!viewerId && task.assignedToUserId === viewerId;
}

export const assignedTaskCardClass =
  "bg-orange-50 border-orange-200 hover:bg-orange-100 dark:bg-orange-950/30 dark:border-orange-800 dark:hover:bg-orange-950/45";